const previewHost = "dev1-1.shengsheng-client.ixiaocong.net";

export function isMockTeamOrderPreview(route, hostname = window.location.hostname) {
  return (
    route.path === "/smile-order/orders" &&
    route.query.mockTeamOrder === "1" &&
    (process.env.NODE_ENV === "development" || hostname === previewHost)
  );
}
